import { generateUtilityClasses } from '../../utils';

export const createPageSkeletonClasses = generateUtilityClasses('CreatePageSkeleton', [
  'root',
  'header',
  'content',
  'formArea',
]);
